import { PROJECT_TAG, PROJECTS_LIST_TAG } from '@/api/constants';
import { api } from '@/api/core';
import type { CreateProjectRequest } from './createProject';
import { updateMockProject } from './mockProjects';
import { mockDelay, readMockProjectError } from './mockUtils';

/** Only the fields present are changed. */
export type UpdateProjectRequest = { projectId: string } & Partial<CreateProjectRequest>;

const MOCK_RESPONSE_DELAY_MS = 600;

const updateProjectApi = api.injectEndpoints({
  endpoints: (builder) => ({
    updateProject: builder.mutation<void, UpdateProjectRequest>({
      // The backend `PATCH /projects/{projectId}` endpoint does not exist yet: edit the mock list (see mockProjects.ts).
      queryFn: async (request, { getState }) => {
        await mockDelay(MOCK_RESPONSE_DELAY_MS);
        const mockError = readMockProjectError();
        if (mockError) return { error: mockError };
        return updateMockProject(request, getState())
          ? { data: undefined }
          : { error: { status: 404, data: 'Project not found' } };
      },
      invalidatesTags: (_result, error, { projectId }) =>
        error ? [] : [{ type: PROJECT_TAG, id: projectId }, { type: PROJECTS_LIST_TAG }],
    }),
  }),
});

export const { useUpdateProjectMutation } = updateProjectApi;
